import React from 'react'
import { NavLink } from '../../lib/Navigation'
import Manager from '../components/Manager'

export default function SearchBar() {
  return (
    <div className='session-search-bar'>
      <NavLink onClick={()=>{
        Manager.push({event_id:'A-5-11-2'})
      }} user={false} to='/chatsearch' className='search-bar-index'>
        <img className='icon' src="/resources/user/ss.png" alt="" />
        <div className='placeholder'>请输入游戏名称搜索群聊</div>
      </NavLink>
    </div>
  )
}
